import React from "react";
import CGCimage from "../../assets/CGC-image.png";
import CSBimage from "../../assets/CGC-image.png";


function About() {
  return (
    <div >
      <div>
  <div className="pt-20 sm:pt-10 flex justify-center">
    <h1 className="text-red-600 mb-0 text-center text-2xl sm:text-3xl md:text-4xl font-bold">
      CGC UNIVERSITY, MOHALI
    </h1>
  </div>
</div>
      <div className="flex flex-wrap">
        <div className="w-full md:w-auto">
          <img src={CGCimage} alt="CGC Jhanjeri" className="w-full md:w-auto" />
        </div>
      </div>
      <div className="flex flex-col md:flex-row items-center justify-center mt-10 p-4">
        <div className="md:w-2/3">
          <h2 className=" text-2xl font-extrabold text-center mb-5">
            ABOUT THE UNIVERSITY
          </h2>
          <div className="p-5 mt-10 text-justify bg-gray-100 rounded-md">
            <p><strong>CGC University, Mohali</strong>, is a leading institution committed to excellence in engineering education, research, and innovation. The university offers a dynamic academic ecosystem supported by modern infrastructure, advanced laboratories, and an outcome-based curriculum that prepares students and researchers to address global technological challenges.</p>

            <p className="pt-5">The <strong>School of Engineering and Technology</strong> at CGC University offers <strong>Undergraduate, Postgraduate, and Ph.D. programs</strong> across core and emerging engineering disciplines including <strong>Computer Science Engineering, Electronics & Communication Engineering, Mechanical Engineering, Civil Engineering</strong>, and interdisciplinary specializations aligned with contemporary industry and research needs. Programs in <strong>Artificial Intelligence, Data Science, Robotics, IoT, Cyber Security</strong>, and advanced M.Tech specializations reflect the university's forward-looking academic vision.</p>

            <p className="pt-5">CGC University maintains <strong>strong industry–academia collaborations with leading national and global organizations</strong>, enabling experiential learning through internships, live projects, industrial training, and expert interactions. These partnerships strengthen research outcomes, enhance employability, and provide valuable real-world exposure to students and scholars.</p>

            <p className="pt-5">By fostering a culture of <strong>innovation, research excellence, and professional ethics</strong>, CGC University, Mohali provides an ideal platform for hosting international conferences that promote <strong>knowledge exchange, interdisciplinary collaboration, and advancement of engineering and technology for societal impact</strong>.</p>

            <div className="pt-5">
              <p>
                <span className="font-extrabold">VISION OF THE SCHOOL:</span> To be a leading institution of engineering and technology, fostering innovation and excellence through new-age curriculum, cutting-edge research, and industry collaboration for the sustainable advancement of society.
              </p>
              <p>
              <span className="font-extrabold">MISSION OF THE SCHOOL:</span>
              </p>
              <ul className="list-disc pl-5">
                <li>Impart quality technical education through outcome-based curriculum that fosters creativity, critical thinking and problem-solving.</li>
                <li>Foster strong industry academia collaborations for knowledge exchange, skill enhancement and employability.</li>
                <li>Promote innovative, entrepreneurial and research culture that addresses real-world challenges and contributes to sustainable development.</li>
                <li>Develop socially responsible, globally competent and ethically grounded engineers.</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="md:w-1/3 mt-5 md:mt-0 md:ml-5">
          <img
            src={CSBimage} alt="Institute Image" className="w-full h-auto rounded-md shadow-md"
          />
        </div>  
      </div>
      <div className="flex flex-col md:flex-row items-center justify-center mt-10 p-4">
  <div className="md:w-1/3  md:mt-0 md:mr-5">
    <img
      src={CGCimage}
      alt="Conference Image"
      className="hidden sm:block w-full h-auto rounded-md shadow-md"
    />
  </div>
  <div className="md:w-2/3">
    <h2 className="text-2xl font-extrabold text-center mb-5">
      ABOUT THE CONFERENCE
    </h2>
    <div className="p-5  text-justify  rounded-md">
      <p>
        The objective of the
        {" "}
        <strong>
        IETACS 2027 - 2<sup>nd</sup> International Conference on Innovations and Emerging Technologies in AI & Communication Systems
        </strong>{" "}
         aims to provide a global platform for researchers, academicians, industry professionals, and practitioners to present, share, and discuss recent advancements, innovations, and challenges in the domains of emerging technologies and intelligent systems. The conference seeks to promote knowledge exchange, interdisciplinary collaboration, and industry–academia interaction, while exploring the integration of AI-driven intelligent systems with next-generation communication technologies to address complex real-world and global challenges.
      </p>
      
    </div>
    <div className="md:w-1/3  md:mt-0 md:mr-5">
    <img
      src={CGCimage}
      alt="Conference Image"
      className="block sm:hidden w-full h-auto rounded-md shadow-md"
    />
  </div>
  </div>
</div>
     
    </div>
  );
}
export default About;
